import NotificationPage from 'components/desktop/pages/Notification';

export default NotificationPage;
